import { NavLink } from 'react-router-dom';
import CustomerHead from '../../components/customer/CustomerHead';

import styled from 'styled-components';

export default function Notification(){
  return (
    <ComplaintWrap>
      <CustomerHead title="Complaint" desc="Voice of Dissatisfaction" />
      <main className="content">
        <div className="card">
          <strong>Customer Requested List</strong>
          <div className="noti-list">
            <div className="table-wrap">
              <table>
                <thead>
                <tr>
                  <th>Notice</th>
                </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <NavLink to='/customer/notice/detail'>알림 내용</NavLink>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <NavLink to='/customer/notice/detail'>알림 내용</NavLink>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <NavLink to='/customer/notice/detail'>알림 내용</NavLink>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </main>
    </ComplaintWrap>
  )
}

const ComplaintWrap = styled.div`
  position: relative;
  background: #F9FAFB;

  .content {
    position:relative;
    padding: 20px;
    height:calc(100vh - 132px);
    overflow-y:auto;

    .card {
      background: #fff;
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      height: 100%;

      strong {
        display: block;
        font-size: 18px;
        font-weight: 700;
        color: #111827;
      }

      .noti-list {
        margin-top: 15px;

        .table-wrap {
          margin-top: 30px;
          position: relative;
          width: 100%;

          table {
            width: 100%;

            th {
              padding: 10px 20px;
              font-weight: 500;
              font-size: 14px;
              color: #fff;
              background: #0072B9;
              vertical-align: middle;
            }

            th + th {
              border-left: 1px solid #fff;
            }

            td {
              padding: 10px 20px;
              font-weight: 500;
              font-size: 14px;
              color: #111;
              border-bottom: 1px solid #d4d4d4;
              text-align: center;
            }

            tr:nth-child(even) td {
              background: #f7f7f7;
            }
          }
        }

      }
    }
  }
`